import {
	OPEN_MODAL,
	CLOSE_MODAL,
	UPDATE_SHIPPING_ADDRESS,
} from '../types/modal';

export const openModal = (name, data) => {
	return {
		type: OPEN_MODAL,
		name,
		data,
	};
};

export const closeModal = () => {
	return {
		type: CLOSE_MODAL,
	};
};

export const updateShippingAddress = (address) => {
	return {
		type: UPDATE_SHIPPING_ADDRESS,
		address,
	};
};
